Wee.fn.make('cart', {
	init: function() {
		var scope = this;

		this.fetchCart();
		this.bind();

		$.screen.map([
			{
				max: 2,
				callback: function() {
					scope.manageCartLocation(false);
				}
			},
			{
				min: 3,
				callback: function() {
					scope.manageCartLocation(true);
				}
			}
		]);
	},

	bind: function() {
		var scope = this;

		$('ref:addToCart').on('click', function(e, el) {
			scope.addToCart($(el).data('value'));

			e.stopPropagation();
		}, {
			delegate: 'main'
		});

		$.events.on({
			'ref:quoteCart': {
				click: function(e) {
					if ($(e.target).hasClass('site-header__icon')) {
						scope.manageQuoteList();
					}

					e.stopPropagation();
				}
			},
			'ref:removeItem': {
				click: function(e, el) {
					if ($(e.target).hasClass('cart-items__remove')) {
						scope.deleteFromCart($(el).data('value'));
					}

					e.stopPropagation();
				}
			}
		}, {
			delegate: 'ref:quoteCart'
		});
	},

	fetchCart: function() {
		var scope = this;

		$.fetch.request({
			url: '/ajax/cart-preview',
			success: function(response) {
				var meta = Wee.$find(Wee.$parseHTML(response), 'meta[data-count]'),
					count = $(meta[0]).data('count'),
					$cartItems = $('ref:cartItems');

				$cartItems.html(response);

				$.setRef();

				$cartItems.find('ref:price').each(function(el) {
					var $el = $(el);

					if ($el.html() == '$0') {
						$el.html('call for pricing');
					}
				});

				scope.updateCount(count);
			}
		});
	},

	addToCart: function(entryId) {
		var scope = this;

		$.fetch.request({
			url: '/ajax/add-to-cart/' + entryId,
			method: 'post',
			type: 'form',
			json: true,
			success: function() {
				scope.fetchCart();

				scope.manageQuoteList();
			}
		});
	},

	deleteFromCart: function(rowId) {
		var scope = this;
		$.fetch.request({
			url: '/ajax/delete-from-cart/' + rowId,
			method: 'post',
			type: 'form',
			json: true,
			headers: {
				'X-Requested-With': false
			},
			success: function() {
				scope.fetchCart();
			}
		});
	},

	updateCount: function(count) {
		if (count !== undefined && parseInt(count) !== 0) {
			$('ref:cartCount').html(count).show();
		} else if (parseInt(count) === 0) {
			$('ref:cartCount').hide();
		}
	},

	manageCartLocation: function(desktop) {
		if (! desktop) {
			$('ref:siteHeader').after($('ref:cartItems'));
		} else {
			$('ref:cartCount').after($('ref:cartItems'));
		}
	},

	manageQuoteList: function() {
		var disabledClass = '-is-disabled',
			$cart = $('ref:cartItems');

		if ($cart.hasClass(disabledClass)) {
			$('ref:cartItems').removeClass(disabledClass);

			setTimeout(function() {
				$(Wee._body).on('click.cart', function() {
					$('ref:cartItems').addClass(disabledClass);

					$(Wee._body).off('click.cart');
				});
			}, 200);
		} else {
			$('ref:cartItems').addClass(disabledClass);

			$(Wee._body).off('click.cart');
		}
	}
});